module.exports = function() {
  return new Worker(__webpack_public_path__ + "e2ba442607f2b1c3c3e0.worker.js");
};